if (!window.__cartCrossSellBound) {
  window.__cartCrossSellBound = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.cart-cross-sell__add[data-variant-id]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var variantId = button.dataset.variantId;
    var originalLabel = button.dataset.originalLabel || button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || 'Could not add item to cart');
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        } else {
          window.location.href =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/') + 'cart';
        }
        button.textContent = originalLabel;
        button.disabled = false;
      })
      .catch(function (error) {
        console.error(error);
        button.textContent = originalLabel;
        button.disabled = false;
      });
  });
}